import { Fragment } from "react";
import { useMember } from "../../context/memberContext";
import { useTranslations } from "../../hooks/useTranslations";
import Label from "../ui/Label";
import Page from "../ui/Page";
import Panel from "../ui/Panel";
import styles from "./MasterData.module.css";

const MasterData = () => {
  const { i18n } = useTranslations();
  const { member } = useMember();

  return (
    <Page
      title={i18n.masterData.title}
      description={i18n.masterData.description}
    >
      <h3 className={styles.title}>{i18n.masterData.memberData.title}</h3>
      <Panel>
        <div className={styles.memberData}>
          <div>
            <Label>{i18n.masterData.name}</Label>
            <strong>{member?.name}</strong>
          </div>
          <div>
            <Label>{i18n.masterData.memberData.memberId}</Label>
            {member?.id}
          </div>
          <div className={styles.street}>
            <Label>{i18n.masterData.street}</Label>
            {member?.street}
          </div>
          <div>
            <Label>{i18n.masterData.city}</Label>
            {member?.city}
          </div>
          <div>
            <Label>{i18n.masterData.postalCode}</Label>
            {member?.zip}
          </div>
          <div>
            <Label>{i18n.masterData.memberData.taxId}</Label>
            {member?.taxCode}
          </div>
          <div>
            <Label>{i18n.masterData.memberData.vatId}</Label>
            {member?.vatNumber}
          </div>
        </div>
      </Panel>
      {member?.companies && (
        <>
          <h3 className={styles.title}>{i18n.masterData.companies.title}</h3>
          <Panel>
            {member.companies.map((company, index) => (
              <Fragment key={index}>
                {index > 0 && <hr className={styles.separator} />}
                <div className={styles.memberData}>
                  <div>
                    <Label>{i18n.masterData.name}</Label>
                    <strong>{company?.name}</strong>
                  </div>
                  <div>
                    <Label>{i18n.masterData.companies.companyId}</Label>
                    {company.id}
                  </div>
                  <div className={styles.street}>
                    <Label>{i18n.masterData.street}</Label>
                    {company.street ?? i18n.notAvailable}
                  </div>
                  <div>
                    <Label>{i18n.masterData.city}</Label>
                    {company.city ?? i18n.notAvailable}
                  </div>
                  <div>
                    <Label>{i18n.masterData.postalCode}</Label>
                    {company.zip ?? i18n.notAvailable}
                  </div>
                </div>
              </Fragment>
            ))}
          </Panel>
        </>
      )}
    </Page>
  );
};

export default MasterData;
